// store.js
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import appReducer from "./redux/app";
import notificationReducer from "./redux/notification";
import reportGeneratorReducer from "./redux/report-generator";
import transcriptionSummaryReducer from "./redux/transcription-summary/index";

const rootReducer = combineReducers({
  notification: notificationReducer,
  reportGenerator: reportGeneratorReducer,
  app: appReducer,
  transcription: transcriptionSummaryReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["transcription"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the Redux store with all reducers
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: import.meta.env.DEV,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

// Debug log the initial state
console.log("Initial Redux State from store.js:", store.getState());

export const persistor = persistStore(store);
